export default __webpack_public_path__ + "static/media/logo.803a706d.svg";